import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext as DNDDragDropContext } from 'react-beautiful-dnd';

const DragDropContext = ({ children, onDragEnd, onDragStart }) => {
  const handleOnDragEnd = (result) => result.destination ? onDragEnd(result) : null;

  const handleOnStart = (initial) => onDragStart(initial);
  
  return(
    <DNDDragDropContext
      onDragEnd={ handleOnDragEnd }
      onDragStart={ handleOnStart }
    >
      { children }
    </DNDDragDropContext>
  );
};

DragDropContext.defaultProps = {
  onDragStart: () => {}
};

DragDropContext.propTypes = {
  children: PropTypes.element.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  onDragStart: PropTypes.func
};

export default DragDropContext;



// WEBPACK FOOTER //
// ./src/shared/components/dragAndDropBeautiful/dragDropContext/DragDropContext.js